import { render, staticRenderFns } from "./ElPreviewsButton.vue?vue&type=template&id=63424087"
import script from "./ElPreviewsButton.vue?vue&type=script&lang=js"
export * from "./ElPreviewsButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports